import type {
  Response,
  EscalatedApplicantResponse,
} from '@/lib/apollo/query/getEscalatedApplicants/query'

import type { TransformedEscalatedApplicantData, TransformedData } from './types'

export const toTransformedEscalatedApplicantData = (
  escalataedApplicant: EscalatedApplicantResponse,
): TransformedEscalatedApplicantData => ({
  ...escalataedApplicant,
})

export const toTransformedData = (response?: Response): TransformedData | undefined =>
  response === undefined
    ? undefined
    : {
        ...response.getEscalatedApplicants,
        results: response.getEscalatedApplicants.results.map(
          toTransformedEscalatedApplicantData,
        ),
      }
